module.exports = __webpack_public_path__ + "static/media/first.6792292e.svg";